<footer class="footer">
  <div class="wrapper wrap">

    <div class="social">
      <ul>
        <li>
          <a href="https://www.facebook.com/solihullcouncil" aria-label="Facebook" title="Facebook">
            <fa-icon [icon]="faFacebookF"></fa-icon>

          </a>
        </li>
        <li>
          <a href="https://www.twitter.com/solihullcouncil" aria-label="Twitter" title="Twitter">
            <fa-icon [icon]="faX"></fa-icon>

          </a>
        </li>
        <li>
          <a href="https://www.youtube.com/channel/UC7DDSVoAIgTnwgp0Ku8iFLQ" aria-label="Youtube Channel"
            title="Youtube Channel">
            <fa-icon [icon]="faYoutube"></fa-icon>

          </a>
        </li>
      </ul>
    </div>

    <div class="post-social">
      <nav>
        <ul class="menu">
          <li class="menu-item">
            <a class="menu-item" href="https://www.solihull.gov.uk/website-privacy-policy">Privacy</a>
          </li>
          <li class="menu-item">
            <a class="menu-item" href="https://www.solihull.gov.uk/site-information">About our site</a>
          </li>
          <li class="menu-item">
            <a class="menu-item" href="https://www.solihull.gov.uk/accessibility-statement-wwwsolihullgovuk">Accessibility statement</a>
          </li>
          <li class="menu-item">
            <a class="menu-item" href="https://www.solihull.gov.uk/tell-us/contact-us">Contact</a>
          </li>
        </ul>
      </nav>

      <div class="copyright">
        <p>&copy; 2025 Solihull Metropolitan Borough Council.</p>
      </div>

      

    </div>

  </div>

</footer>